import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import {
	ChevronRightIcon,
	CheckCircleIcon } from '@heroicons/react/outline'

const PRIORITY_ORDER = {
	critical: 0,
	important: 1,
	info: 2
}

const PRIORITY_PILLS = {
	critical: { label: 'À faire', classes: 'bg-emerald-100 text-emerald-700' },
	important: { label: 'Important', classes: 'bg-amber-100 text-amber-700' },
	info: { label: 'Conseil', classes: 'bg-sky-100 text-sky-700' }
}

class RecommendedActions extends Component {
	_renderSkeleton = () => {
		return (
			<div>
				<div className="h-3 bg-slate-200 rounded-full w-40 mb-3 animate-pulse"></div>
				<div className="bg-white border border-slate-200 rounded-2xl shadow-sm p-5 animate-pulse">
					<div className="h-10 bg-slate-100 rounded-xl mb-3"></div>
					<div className="h-10 bg-slate-100 rounded-xl"></div>
				</div>
			</div>
		)
	}

	_renderAction = (action) => {
		const pill = PRIORITY_PILLS[action.priority] || PRIORITY_PILLS.info
		return (
			<Link
				key={action.id}
				to={action.cta.to}
				className="group flex items-center gap-4 px-5 py-4 cursor-pointer transition-colors hover:bg-slate-50 border-b border-slate-100 last:border-0 focus:outline-none focus:ring-2 focus:ring-indigo-500"
			>
				<span className={'text-3xs font-black uppercase tracking-wider px-2.5 py-1 rounded-full flex-shrink-0 ' + pill.classes}>
					{pill.label}
				</span>
				<div className="flex-1 min-w-0">
					<p className="text-sm font-bold text-slate-800 my-0 group-hover:text-indigo-600 transition-colors">{action.title}</p>
					{action.detail &&
						<p className="text-xs font-medium text-slate-400 my-0 mt-0.5 truncate">{action.detail}</p>
					}
				</div>
				<span className="hidden sm:flex items-center gap-1 text-2xs font-black uppercase tracking-widest text-indigo-600 flex-shrink-0 whitespace-nowrap">
					{action.cta.label}
					<ChevronRightIcon className="w-4 h-4 transition-transform group-hover:translate-x-0.5" aria-hidden="true" />
				</span>
				<ChevronRightIcon className="sm:hidden w-4 h-4 text-slate-300 flex-shrink-0 transition-transform group-hover:translate-x-0.5" aria-hidden="true" />
			</Link>
		)
	}

	render() {
		if (this.props.loading === true)
			return this._renderSkeleton()
		let actions = this.props.actions ? this.props.actions.slice() : []
		actions.sort((a, b) => {
			return (PRIORITY_ORDER[a.priority] || 0) - (PRIORITY_ORDER[b.priority] || 0)
		})
		actions = actions.slice(0, 5)
		return (
			<div>
				<div className="flex items-center gap-2 mb-3">
					<h2 className="text-2xs font-black text-slate-400 uppercase tracking-widest my-0">À faire en priorité</h2>
					{actions.length > 0 &&
						<span className="text-2xs font-black px-2 py-0.5 rounded-full bg-emerald-100 text-emerald-600">{actions.length}</span>
					}
				</div>
				<div className="bg-white border border-slate-200 rounded-2xl shadow-sm overflow-hidden">
					{actions.length === 0 &&
						<div className="flex items-center gap-3 px-5 py-4">
							<div className="w-9 h-9 rounded-xl bg-emerald-50 flex items-center justify-center flex-shrink-0">
								<CheckCircleIcon className="w-5 h-5 text-emerald-600" aria-hidden="true" />
							</div>
							<div>
								<p className="text-sm font-bold text-slate-800 my-0">Rien à faire pour le moment.</p>
								<p className="text-xs font-medium text-slate-400 my-0 mt-0.5">Tout est à jour, profitez-en pour préparer la suite.</p>
							</div>
						</div>
					}
					{actions.map(action => this._renderAction(action))}
				</div>
			</div>
		)
	}
}

export default RecommendedActions
